import axios from 'axios';

// API base configuration
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('[API Client] Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle common errors
apiClient.interceptors.response.use(
  (response) => {
    // For blob responses (file downloads), return the blob directly
    if (response.config.responseType === 'blob') {
      return response.data;
    }
    
    // For login/register endpoints, return the full data object containing user and token
    if (response.config.url?.includes('/auth/login') || response.config.url?.includes('/auth/register')) {
      return response.data.data || response.data;
    }
    
    // For /auth/me endpoint, extract user from nested structure
    if (response.config.url?.includes('/auth/me') || response.config.url?.includes('/auth/check')) {
      const userData = response.data.data?.user || response.data.user || response.data;
      return userData;
    }
    
    // For other endpoints, return the data
    const result = response.data.data || response.data;
    return result;
  },
  (error) => {
    // Handle 401 unauthorized errors ONLY if token is actually expired or invalid
    if (error.response?.status === 401) {
      const errorCode = error.response?.data?.error;
      
      // Only auto-logout for token expiration or invalid token, not for other auth errors
      if (errorCode === 'Token expired' || errorCode === 'Invalid token' || 
          error.response?.data?.message?.includes('expired') ||
          error.response?.data?.message?.includes('invalid')) {
        
        // Don't auto-redirect if we're already on login/register page
        const currentPath = window.location.pathname;
        if (!currentPath.includes('/login') && !currentPath.includes('/register')) {
          localStorage.removeItem('token');
          
          // Use a flag to prevent multiple redirects
          if (!window.isRedirecting) {
            window.isRedirecting = true;
            setTimeout(() => {
              window.isRedirecting = false;
              window.location.href = '/login';
            }, 100);
          }
        }
      }
    }
    
    // Re-throw the error for handling in components
    return Promise.reject(error);
  }
);

export default apiClient;